import './Playground.css';

export const Playground = ({children})=>{
    return(
        <div className='play-ground'>
           
            {children}

        </div>
    );
}
